import { useContext } from 'react';

import { ExcelImporterStepperContext } from './ExcelImporterStepperContext';
import type { IExcelImporterStepperState } from './types';

export function useExcelImporterStepperContext(): IExcelImporterStepperState {
  const context = useContext(ExcelImporterStepperContext);

  if (context === undefined) {
    throw new Error('ExcelImporterStepperContext.Provider is not used.');
  }

  return context;
}

export { default as ExcelImporterStepperProvider } from './ExcelImporterStepperContext';
